export const joinClasses = classes => classes.join(' ');
